import React from "react"

const CalendarEventWrapper = ({ event, children }) => {
  return <div className="relative mouse-event-wrapper">{children}</div>
}

export default CalendarEventWrapper
